import React from "react";
import { useLocation } from "react-router-dom";
import "./footer.css";

export const Footer = () => {
  const location = useLocation();
  const currentRoute = location.pathname;

  return (
    <div className="container footer ">
      <footer className="d-flex flex-wrap justify-content-between align-items-center py-2 border-top border-1">
        <div className="col-md-2 d-flex align-items-center">
          <a
            href="/"
            className="mb-1 mb-md-0 text-body-secondary text-decoration-none lh-1"
          >
            <img
              className="bi"
              width={40}
              height={40}
              src="./myport.png"
              alt="logo"
            />
          </a>
          <span className="mb-1 mb-md-0 text-light">
            © 2023 My Portfolio, Inc
          </span>
        </div>

        <div className="text-light">
          {currentRoute === ("/" || "/signup") ? (
            ""
          ) : (
            <>
              Ready to showcase your skills?{" "}
              <a href="/">Create your portfolio</a> now!
            </>
          )}
          {currentRoute === "/" || currentRoute === "/signup" ? (
            <>
            
              <p className="text-center mb-1 mb-md-0">
                This web application was developed and designed by the AR team (
                <a href="/anilreddykota" className="text-light">
                  Anil Reddy
                </a>{" "}
                &{" "}
                <a href="/ramsaiandhavarapu" className="text-light">
                  Ramsai
                </a>
                ){" "}
              </p>
            </>
          ) : null}
        </div>

        <ul className="nav justify-content-end list-unstyled d-flex">
          <li className="ms-3">
            <a className="text-light" href="/anilreddykota">
              <i className="fa-brands fa-instagram"></i>
            </a>
          </li>
          <li className="ms-3">
            <a className="text-light" href="/anilreddykota">
              <i className="fa-brands fa-facebook"></i>
            </a>
          </li>
          <li className="ms-3">
            <a className="text-light" href="/ramsaiandhavarapu">
              <i className="fa-brands fa-twitter"></i>
            </a>
          </li>
        </ul>
      </footer>
    </div>
  );
};
